import React from "react";

import { components, GroupBase, MultiValueProps } from "react-select";

export type ClickableMultiValueProps<
  Option extends { value: string } = { label: string; value: string },
  IsMulti extends boolean = true,
> = MultiValueProps<Option, IsMulti, GroupBase<Option>> & {
  onClick: (
    e: React.MouseEvent<HTMLDivElement>,
    props: MultiValueProps<Option, IsMulti, GroupBase<Option>>
  ) => void;
  editingKeyword?: string | null;
};

export function ClickableMultiValue<
  Option extends { value: string } = { label: string; value: string },
  IsMulti extends boolean = true,
>(props: ClickableMultiValueProps<Option, IsMulti>) {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    props.onClick(e, props);
  };

  return props.editingKeyword !== props.data.value ? (
    <div onClick={handleClick}>
      <components.MultiValue {...props} />
    </div>
  ) : null;
}

export default ClickableMultiValue;
